import { styled, Box } from '@mui/material';

/**
 * PageContainer - A full-height page container with responsive padding
 *
 * Provides consistent page layout with theme-aware background gradient.
 * Responsive padding adjusts for mobile/tablet screens.
 *
 * @see src/modules/TeamModule/components/TeamsV2Page.tsx
 * @see src/modules/ReportsModule/TeamsOverviewPage.tsx
 */
export const PageContainer = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  background: 'transparent', // Changed from theme.palette.background.default to show gradient
  padding: theme.spacing(4, 6),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(3),
  },
}));
